module.exports = __webpack_public_path__ + "360cd53aa16adc41f320a382b2ae1d2d.png";